<ng-container *ngIf="form" [formGroup]="form">
    <mat-form-field appearance="fill" class="w-full mb-2">
        <mat-label>{{ label }}</mat-label>
        <mat-select [id]="id" [formControlName]="name" [required]="required">
            <mat-option *ngFor="let option of options" [id]="id + '-' + option.value" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="control?.invalid" [id]="id + '-error'">{{ errorMessage }}</mat-error>
    </mat-form-field>
</ng-container>